import { Typography, Chip, useTheme } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import type { GridColDef } from '@mui/x-data-grid';

export const getLockerColumns = (): GridColDef[] => [
  { field: 'name', headerName: 'Nome', flex: 1 },
  { 
    field: 'is_available', 
    headerName: 'Status', 
    width: 120,
    renderCell: (params: any) => (
      <Chip 
        icon={params.value ? <CheckCircleIcon sx={{ fontSize: '16px !important' }} /> : <CancelIcon sx={{ fontSize: '16px !important' }} />}
        label={params.value ? 'Disponível' : 'Indisponível'} 
        color={params.value ? 'success' : 'error'}
        size="small"
        variant="outlined"
      />
    )
  },
  { 
    field: 'port', 
    headerName: 'Porta', 
    width: 80,
    renderCell: (params: any) => (
      <Typography 
        sx={{ 
          fontFamily: 'monospace', 
          fontSize: 12,
          backgroundColor: '#F3F4F6',
          color: '#111827',
          px: 1,
          py: 0.5,
          borderRadius: 1,
          textAlign: 'center'
        }}
      >
        {params.value || 'N/A'}
      </Typography>
    )
  },
  { 
    field: 'mac', 
    headerName: 'MAC', 
    width: 140,
    renderCell: (params: any) => (
      <Typography 
        sx={{ 
          fontFamily: 'monospace', 
          fontSize: 11,
          backgroundColor: '#F3F4F6',
          color: '#111827',
          px: 1,
          py: 0.5,
          borderRadius: 1
        }}
      >
        {params.value || 'N/A'}
      </Typography>
    )
  },
  { field: 'manufacturerName', headerName: 'Fabricante', flex: 1 },
  { field: 'roomName', headerName: 'Área', flex: 1 },
  { field: 'tenantName', headerName: 'Empresa', flex: 1 },
]; 